export const ChoresFormFamily = {
  title: 'Chores',
  formVersion: 1,
  description: 'Client Chores Intake Form',
  formKey: 'CLIENT_CHORES_INTAKE_FORM',
  questions: {
    'Chores-help': {
      questionId: 'Chores-help',
      fieldType: 'checkbox',
      rank: 1,
      questionData: {
        label: 'What do they need help with around the house?',
        helpText: '',
        required: true,
      },
      options: [
        {value: 'light-cleaning', label: 'Light cleaning (dusting, wiping surfaces)', isOther: false},
        {value: 'vacuuming', label: 'Vacuuming or mopping', isOther: false},
        {value: 'laundry', label: 'Laundry', isOther: false},
        {value: 'bedding', label: 'Changing bedding', isOther: false},
        {value: 'dishes', label: 'Washing dishes', isOther: false},
        {value: 'organizing', label: 'Organizing or tidying', isOther: false},
        {value: 'garbage', label: 'Taking out garbage or recycling', isOther: false},
        {value: 'other', label: 'Other', isOther: true},
      ],
    },
  },
};
